// removed by extract-text-webpack-plugin
module.exports = {"accordeon":"_2e4Be0F4zi_yLMMkO0KDT_","title":"_25CAEwORRKPvlhBRrqcoYR","triangleRight":"_1K0VHAfqz7gUl8L1VCKytG","triangleDown":"WiUpU7aUZIZOOSZlOhn6b","closed":"LfHBw6dIOtzDruEuXCVDx"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/firstDown/css/accordion.css
// module id = 833
// module chunks = 0